<template>
  <ContentWrap>
    <el-alert
      class="mb-16px"
      type="info"
      :closable="false"
      title="同时作用于 C 端商城首页顶栏品牌标与「系统设置」名称/头像。清空并保存后回落默认名称与静态默认图。不绑跳转。"
    />
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      label-width="120px"
    >
      <el-form-item label="商城名称" prop="name">
        <el-input
          v-model="formData.name"
          class="!w-400px"
          clearable
          maxlength="64"
          placeholder="空则 C 端显示默认名「紫金山云谷商城」"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="品牌 Logo" prop="picUrl">
        <UploadImg v-model="formData.picUrl" height="112px" width="112px" />
        <div class="el-upload__tip" style="line-height: 1.4; margin-top: 6px">
          建议尺寸 <b>112×112～256×256</b> px，透明底 PNG；首页约 56×56rpx，系统设置约 160×160rpx
        </div>
      </el-form-item>
      <el-form-item>
        <el-button
          v-hasPermi="['promotion:home-brand:update']"
          :loading="formLoading"
          type="primary"
          @click="submitForm"
        >
          保 存
        </el-button>
        <el-button
          v-hasPermi="['promotion:home-brand:update']"
          :disabled="formLoading || (!formData.picUrl && !formData.name)"
          @click="clearBrand"
        >
          清 空
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>
</template>

<script lang="ts" setup>
import * as HomeBrandApi from '@/api/mall/market/homeBrand'

defineOptions({ name: 'PromotionHomeBrand' })

const message = useMessage()

const formLoading = ref(false)
const formData = ref<HomeBrandApi.HomeBrandVO>({
  name: '',
  picUrl: ''
})

const getForm = async () => {
  formLoading.value = true
  try {
    const data = await HomeBrandApi.getHomeBrand()
    formData.value = {
      id: data?.id,
      name: data?.name || '',
      picUrl: data?.picUrl || ''
    }
  } finally {
    formLoading.value = false
  }
}

const clearBrand = () => {
  formData.value.name = ''
  formData.value.picUrl = ''
}

const submitForm = async () => {
  formLoading.value = true
  try {
    await HomeBrandApi.saveHomeBrand({
      name: formData.value.name || '',
      picUrl: formData.value.picUrl || ''
    })
    message.success('保存成功')
    await getForm()
  } finally {
    formLoading.value = false
  }
}

onMounted(() => {
  getForm()
})
</script>
